import { render } from "./PageRanking.vue?vue&type=template&id=2884cb4a"
import script from "./PageRanking.vue?vue&type=script&lang=js"
export * from "./PageRanking.vue?vue&type=script&lang=js"

import "./PageRanking.vue?vue&type=style&index=0&id=2884cb4a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__